(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["color-3d-viewer"] && !Shopify.designMode) return;
  try {
    (function () {
    var THREE_CDN = 'https://cdn.jsdelivr.net/npm/three@0.169.0';

    function loadThreeModules() {
      if (!window.__m3dThreePromise) {
        var p = Promise.all([
          import(THREE_CDN + '/+esm'),
          import(THREE_CDN + '/examples/jsm/controls/OrbitControls.js/+esm'),
          import(THREE_CDN + '/examples/jsm/loaders/GLTFLoader.js/+esm'),
          import(THREE_CDN + '/examples/jsm/environments/RoomEnvironment.js/+esm'),
        ]).then(function (mods) {
          return {
            THREE: mods[0],
            OrbitControls: mods[1].OrbitControls,
            GLTFLoader: mods[2].GLTFLoader,
            RoomEnvironment: mods[3].RoomEnvironment,
          };
        });
        // Transiente CDN-Fehler nicht dauerhaft cachen — naechster Viewer versucht es erneut
        p.catch(function () {
          if (window.__m3dThreePromise === p) window.__m3dThreePromise = null;
        });
        window.__m3dThreePromise = p;
      }
      return window.__m3dThreePromise;
    }

    var AUTO_ROTATE_SPEED = (18 * Math.PI) / 180; // rad/s, wie zuvor 18deg/s
    var FLAT_PENDULUM_MAX_ANGLE = (35 * Math.PI) / 180; // flache Objekte (Scheiben/Medaillons): Pendeln statt Vollrotation
    var FLAT_PENDULUM_SPEED = 0.5; // rad/s (Sinus-Frequenz)
    var FLAT_ASPECT_THRESHOLD = 0.25; // kleinste/groesste Bounding-Box-Dimension < 25% -> gilt als "flach"
    var LIGHT_AZIMUTH_SPEED = 0.55; // rad/s — Licht kreist dauerhaft
    var LIGHT_ELEVATION_BASE = (40 * Math.PI) / 180;
    var LIGHT_ELEVATION_SWING = (25 * Math.PI) / 180;
    var LIGHT_ELEVATION_SPEED = 0.23;
    var AUTO_ROTATE_RESUME_MS = 1200;
    var REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    class Color3dViewer extends HTMLElement {
      connectedCallback() {
        // Token statt Boolean: Pending-Promises aus einem frueheren Attach
        // erkennen einen Re-Attach am Token-Mismatch und brechen ab
        this._attachToken = {};
        this._ac = new AbortController();
        var signal = this._ac.signal;

        this.stages = Array.from(this.querySelectorAll('.color-3d-viewer__stage-wrap')).map((wrap) => {
          var host = wrap.querySelector('.color-3d-viewer__stage');
          var rotateBtn = wrap.querySelector('.color-3d-viewer__rotate-btn');
          var existingMv = host ? host.querySelector('model-viewer') : null;
          return {
            wrap: wrap,
            host: host,
            spinner: wrap.querySelector('.color-3d-viewer__spinner'),
            fullscreenBtn: wrap.querySelector('.color-3d-viewer__fullscreen-btn'),
            rotateBtn: rotateBtn,
            loaded: !!(existingMv && existingMv.model),
            spinning: REDUCED_MOTION ? false : rotateBtn ? rotateBtn.dataset.spinning !== 'false' : true,
            interacting: false,
            resumeTimer: 0,
            three: null,
            mv: existingMv,
            started: !!existingMv,
            visible: false,
            raf: 0,
            lastTime: 0,
            elapsed: 0,
            errorShown: false,
            loadTimer: 0,
            flatObject: false,
          };
        });

        try {
          this.bodyColors = JSON.parse(this.dataset.bodyColors || '{}');
        } catch (e) {
          this.bodyColors = {};
        }
        this.pendingBody = null;
        this.pendingSecondary = null;
        this._secondaryWired = false;

        this.wireNativeFarbe();

        this.stages.forEach((stage) => {
          this.syncRotateBtn(stage);
          if (stage.fullscreenBtn) {
            stage.fullscreenBtn.addEventListener('click', () => this.toggleFullscreen(stage), { signal: signal });
          }
          if (stage.rotateBtn) {
            stage.rotateBtn.addEventListener('click', () => this.toggleRotation(stage), { signal: signal });
          }
          // Re-Attach nach frueherem Fallback: vorhandenen model-viewer weiterverwenden
          if (stage.mv && !stage.loaded) {
            stage.mv.addEventListener('load', () => this.onFallbackLoad(stage), { once: true, signal: signal });
          }
        });

        // Erst initialisieren, wenn der Viewer in Viewport-Naehe kommt
        this._io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              var stage = this.stages.find((s) => s.wrap === entry.target);
              if (!stage) return;
              stage.visible = entry.isIntersecting;
              if (entry.isIntersecting && !stage.started) {
                stage.started = true;
                this.initStage(stage);
              }
              if (stage.three) {
                if (entry.isIntersecting) this.startLoop(stage);
                else this.stopLoop(stage);
              }
            });
          },
          { rootMargin: '200px' }
        );
        this.stages.forEach((stage) => this._io.observe(stage.wrap));
      }

      disconnectedCallback() {
        this._attachToken = null;
        if (this._ac) this._ac.abort();
        if (this._io) this._io.disconnect();
        this.stages.forEach((stage) => {
          if (stage.loadTimer) clearTimeout(stage.loadTimer);
          if (stage.resumeTimer) clearTimeout(stage.resumeTimer);
          this.teardownThree(stage);
        });
      }

      teardownThree(stage) {
        this.stopLoop(stage);
        var t = stage.three;
        if (!t) return;
        stage.three = null;
        if (t.resizeObserver) t.resizeObserver.disconnect();
        if (t.controls) t.controls.dispose();
        if (t.renderer) {
          t.renderer.dispose();
          try {
            t.renderer.forceContextLoss();
          } catch (e) {
            /* Kontext ggf. schon verloren */
          }
          var el = t.renderer.domElement;
          if (el && el.parentNode) el.parentNode.removeChild(el);
        }
      }

      /* ---------- Three.js-Aufbau ---------- */

      initStage(stage) {
        var self = this;
        var token = this._attachToken;
        loadThreeModules()
          .then(function (mods) {
            if (self._attachToken !== token) return;
            return self.buildThreeStage(stage, mods, token);
          })
          .catch(function (err) {
            if (self._attachToken !== token) return;
            console.warn('color-3d-viewer: Three.js-Viewer nicht verfuegbar, fallback auf model-viewer', err);
            self.fallbackToModelViewer(stage);
          });
      }

      buildThreeStage(stage, mods, token) {
        var self = this;
        var THREE = mods.THREE;
        var host = stage.host;

        var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
        renderer.outputColorSpace = THREE.SRGBColorSpace;
        renderer.toneMapping = THREE.ACESFilmicToneMapping;
        renderer.toneMappingExposure = 1.0;
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        host.appendChild(renderer.domElement);

        var scene = new THREE.Scene();
        var pmrem = new THREE.PMREMGenerator(renderer);
        scene.environment = pmrem.fromScene(new mods.RoomEnvironment(), 0.04).texture;
        if ('environmentIntensity' in scene) scene.environmentIntensity = 0.25;
        pmrem.dispose();

        var camera = new THREE.PerspectiveCamera(30, 4 / 3, 0.1, 100);

        var turntable = new THREE.Group();
        scene.add(turntable);

        var keyLight = new THREE.DirectionalLight(0xffffff, 2.2);
        keyLight.castShadow = true;
        scene.add(keyLight);
        scene.add(keyLight.target);

        var fillLight = new THREE.DirectionalLight(0xffffff, 0.35);
        scene.add(fillLight);
        scene.add(fillLight.target);

        var controls = new mods.OrbitControls(camera, renderer.domElement);
        controls.enableDamping = true;
        controls.dampingFactor = 0.08;
        controls.enablePan = false;
        // Voller Polarbereich 0-180 Grad, Azimut unbegrenzt (OrbitControls klemmt an den Polen)
        // pan-y statt OrbitControls-Default 'none': vertikaler Ein-Finger-Wisch scrollt
        // weiter die Seite (wie beim alten model-viewer), horizontale Geste dreht
        renderer.domElement.style.touchAction = 'pan-y';

        // Auto-Rotation pausiert waehrend Interaktion, Resume nach 1200ms (wie model-viewer)
        controls.addEventListener('start', function () {
          stage.interacting = true;
          if (stage.resumeTimer) clearTimeout(stage.resumeTimer);
        });
        controls.addEventListener('end', function () {
          if (stage.resumeTimer) clearTimeout(stage.resumeTimer);
          stage.resumeTimer = setTimeout(function () {
            stage.interacting = false;
          }, AUTO_ROTATE_RESUME_MS);
        });

        stage.three = {
          THREE: THREE,
          renderer: renderer,
          scene: scene,
          camera: camera,
          controls: controls,
          turntable: turntable,
          keyLight: keyLight,
          fillLight: fillLight,
          lightRadius: 3,
          resizeObserver: null,
        };

        var resize = function () {
          if (!stage.three) return;
          var w = host.clientWidth || 1;
          var h = host.clientHeight || 1;
          renderer.setSize(w, h, false);
          camera.aspect = w / h;
          camera.updateProjectionMatrix();
        };
        resize();
        stage.three.resizeObserver = new ResizeObserver(resize);
        stage.three.resizeObserver.observe(host);

        var loader = new mods.GLTFLoader();
        return loader.loadAsync(host.dataset.src).then(function (gltf) {
          if (self._attachToken !== token || !stage.three) {
            self.teardownThree(stage);
            return;
          }

          var object = gltf.scene;
          var box = new THREE.Box3().setFromObject(object);
          var sphere = box.getBoundingSphere(new THREE.Sphere());
          var center = sphere.center;
          object.position.sub(center);
          turntable.add(object);

          var r = Math.max(sphere.radius, 0.001);

          // Flache Objekte (Scheiben/Medaillons) erkennen: kleinste Bounding-Box-Dimension
          // deutlich kleiner als groesste -> Auto-Rotation pendelt statt durchzudrehen,
          // sonst zeigt die Dauerdrehung periodisch die duenne Kante (papierduenn wirkend).
          // Manuelles Drehen durch den Nutzer bleibt davon unberuehrt, bleibt frei in alle Richtungen.
          var size = box.getSize(new THREE.Vector3());
          var dims = [size.x, size.y, size.z].sort(function (a, b) { return a - b; });
          stage.flatObject = dims[2] > 0 && dims[0] / dims[2] < FLAT_ASPECT_THRESHOLD;

          object.traverse(function (node) {
            if (node.isMesh) {
              node.castShadow = true;
              node.receiveShadow = true;
            }
          });

          // Schatten-Frustum auf Modellgroesse einstellen
          var lightRadius = r * 2.6;
          stage.three.lightRadius = lightRadius;
          keyLight.shadow.mapSize.set(1024, 1024);
          keyLight.shadow.camera.left = -r * 1.5;
          keyLight.shadow.camera.right = r * 1.5;
          keyLight.shadow.camera.top = r * 1.5;
          keyLight.shadow.camera.bottom = -r * 1.5;
          keyLight.shadow.camera.near = 0.05;
          keyLight.shadow.camera.far = lightRadius + r * 3;
          keyLight.shadow.bias = -0.0002;
          keyLight.shadow.normalBias = r * 0.01;
          keyLight.shadow.camera.updateProjectionMatrix();

          // Kamera wie zuvor: leicht erhoehte Frontansicht
          var fov = (camera.fov * Math.PI) / 180;
          var fitDist = (r / Math.tan(fov / 2)) * 1.15;
          camera.near = fitDist * 0.01;
          camera.far = fitDist * 50;
          camera.position.set(0, fitDist * Math.cos((75 * Math.PI) / 180), fitDist * Math.sin((75 * Math.PI) / 180));
          camera.updateProjectionMatrix();
          controls.minDistance = fitDist * 0.35;
          controls.maxDistance = fitDist * 3;
          controls.target.set(0, 0, 0);
          controls.update();

          stage.loaded = true;
          if (stage.spinner) stage.spinner.remove();

          self.onModelLoad(stage);
          if (stage.visible) self.startLoop(stage);
        });
      }

      startLoop(stage) {
        if (!stage.three || stage.raf) return;
        var self = this;
        stage.lastTime = 0;
        var tick = function (now) {
          if (!stage.three) {
            stage.raf = 0;
            return;
          }
          stage.raf = requestAnimationFrame(tick);
          if (!stage.lastTime) stage.lastTime = now;
          var delta = Math.min((now - stage.lastTime) / 1000, 0.1);
          stage.lastTime = now;
          if (!REDUCED_MOTION) stage.elapsed += delta;

          if (stage.spinning && !stage.interacting && !REDUCED_MOTION) {
            if (stage.flatObject) {
              // Pendeln statt Vollrotation: Motiv bleibt immer lesbar, keine Kantenansicht
              stage.three.turntable.rotation.y = Math.sin(stage.elapsed * FLAT_PENDULUM_SPEED) * FLAT_PENDULUM_MAX_ANGLE;
            } else {
              stage.three.turntable.rotation.y += AUTO_ROTATE_SPEED * delta;
            }
          }

          // Licht kreist dauerhaft — unabhaengig von Interaktion und Pause
          // (bei prefers-reduced-motion steht es fest auf der Basisposition)
          var t = stage.elapsed;
          var az = t * LIGHT_AZIMUTH_SPEED;
          var el = LIGHT_ELEVATION_BASE + LIGHT_ELEVATION_SWING * Math.sin(t * LIGHT_ELEVATION_SPEED);
          var R = stage.three.lightRadius;
          stage.three.keyLight.position.set(
            R * Math.cos(el) * Math.sin(az),
            R * Math.sin(el),
            R * Math.cos(el) * Math.cos(az)
          );
          var fillAz = az + Math.PI * 0.9;
          var fillEl = (20 * Math.PI) / 180;
          stage.three.fillLight.position.set(
            R * Math.cos(fillEl) * Math.sin(fillAz),
            R * Math.sin(fillEl),
            R * Math.cos(fillEl) * Math.cos(fillAz)
          );

          stage.three.controls.update();
          stage.three.renderer.render(stage.three.scene, stage.three.camera);
        };
        stage.raf = requestAnimationFrame(tick);
      }

      stopLoop(stage) {
        if (stage.raf) {
          cancelAnimationFrame(stage.raf);
          stage.raf = 0;
        }
        stage.lastTime = 0;
      }

      /* ---------- Fallback: model-viewer wie bisher ---------- */

      fallbackToModelViewer(stage) {
        // Teilinitialisierten Three-Zustand vollstaendig abbauen, sonst laufen
        // materialNames/applyColorHex spaeter gegen die leere Three-Szene
        this.teardownThree(stage);

        if (!customElements.get('model-viewer') && !document.querySelector('script[data-m3d-mv]')) {
          var s = document.createElement('script');
          s.type = 'module';
          s.dataset.m3dMv = '1';
          s.src = 'https://unpkg.com/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
          document.head.appendChild(s);
        }
        var host = stage.host;
        var mv = document.createElement('model-viewer');
        mv.setAttribute('src', host.dataset.src);
        mv.setAttribute('alt', host.getAttribute('aria-label') || '');
        mv.setAttribute('camera-controls', '');
        mv.setAttribute('camera-orbit', '0deg 75deg auto');
        if (stage.spinning) mv.setAttribute('auto-rotate', '');
        mv.setAttribute('auto-rotate-delay', '1200');
        mv.setAttribute('rotation-per-second', '18deg');
        mv.setAttribute('shadow-intensity', '0.8');
        mv.setAttribute('exposure', '0.65');
        mv.setAttribute('tone-mapping', 'commerce');
        mv.setAttribute('interaction-prompt', 'none');
        host.appendChild(mv);
        stage.mv = mv;
        var signal = this._ac ? this._ac.signal : undefined;
        mv.addEventListener('load', () => this.onFallbackLoad(stage), { once: true, signal: signal });
        mv.addEventListener('error', () => this.showStageError(stage), { signal: signal });
        // Laedt auch der Fallback nicht (GLB kaputt, unpkg geblockt), Fehler statt Endlos-Spinner
        stage.loadTimer = setTimeout(() => {
          if (!stage.loaded) this.showStageError(stage);
        }, 15000);
      }

      onFallbackLoad(stage) {
        if (stage.loadTimer) {
          clearTimeout(stage.loadTimer);
          stage.loadTimer = 0;
        }
        var err = stage.host.querySelector('.color-3d-viewer__error');
        if (err) err.remove();
        stage.errorShown = false;
        stage.loaded = true;
        if (stage.spinner) stage.spinner.remove();
        this.onModelLoad(stage);
      }

      showStageError(stage) {
        if (stage.errorShown) return;
        stage.errorShown = true;
        if (stage.spinner) stage.spinner.remove();
        var div = document.createElement('div');
        div.className = 'color-3d-viewer__error';
        div.textContent = '3D-Ansicht konnte nicht geladen werden.';
        stage.host.appendChild(div);
      }

      /* ---------- Farb-Logik (unveraendert nach aussen) ---------- */

      wireNativeFarbe() {
        var optionName = this.dataset.colorOptionName;
        if (!optionName) return;
        var inputs = Array.from(document.querySelectorAll('input[type="radio"]')).filter(
          (i) => i.name && i.name.indexOf(optionName + '-') === 0
        );
        if (!inputs.length) return;
        var signal = this._ac ? this._ac.signal : undefined;
        inputs.forEach((input) => {
          input.addEventListener('change', () => this.setBodyColor(input.value), { signal: signal });
        });
        var checked = inputs.find((i) => i.checked);
        if (checked) this.setBodyColor(checked.value);
      }

      wireNativeSecondary() {
        var labelEl = Array.from(document.querySelectorAll('*')).find(
          (el) => el.children.length === 0 && el.textContent.trim() === 'Zweite Farbe'
        );
        if (!labelEl) return false;
        var group = labelEl.closest('.gpo-group');
        if (!group) return false;
        var inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
        if (!inputs.length) return false;
        var signal = this._ac ? this._ac.signal : undefined;
        inputs.forEach((input) => {
          input.addEventListener('change', () => this.setSecondaryColor(this.readGloboHex(input)), { signal: signal });
        });
        var checked = inputs.find((i) => i.checked) || inputs[0];
        if (checked) this.setSecondaryColor(this.readGloboHex(checked));
        return true;
      }

      readGloboHex(input) {
        if (input.dataset.color1) return input.dataset.color1;
        var item = input.closest('.gpo-ov-item') || input.parentElement;
        var sw = item ? item.querySelector('[style*="background-color"]') : null;
        if (!sw) return null;
        var m = sw.getAttribute('style').match(/background-color:\s*(#[0-9a-fA-F]{3,8})/);
        return m ? m[1] : null;
      }

      setBodyColor(name) {
        var hex = this.bodyColors[name];
        if (!hex) return;
        this.pendingBody = hex;
        this.stages.forEach((stage) => this.applyColorHex(stage, hex, 'Body'));
      }

      setSecondaryColor(hex) {
        if (!hex) return;
        this.pendingSecondary = hex;
        this.stages.forEach((stage) => this.applyColorHex(stage, hex, 'Secondary'));
      }

      materialNames(stage) {
        if (stage.three) {
          var names = [];
          stage.three.turntable.traverse(function (node) {
            if (!node.isMesh || !node.material) return;
            var mats = Array.isArray(node.material) ? node.material : [node.material];
            mats.forEach(function (mat) {
              if (names.indexOf(mat.name) === -1) names.push(mat.name);
            });
          });
          return names;
        }
        if (stage.mv && stage.mv.model) {
          return stage.mv.model.materials.map((m) => m.name);
        }
        return [];
      }

      onModelLoad(stage) {
        if (this.pendingBody) this.applyColorHex(stage, this.pendingBody, 'Body');
        if (this.pendingSecondary) this.applyColorHex(stage, this.pendingSecondary, 'Secondary');

        var names = this.materialNames(stage);
        if (names.indexOf('Secondary') === -1 || this._secondaryWired) return;

        var attempts = 0;
        var signal = this._ac ? this._ac.signal : null;
        var tryWire = () => {
          if (signal && signal.aborted) return;
          attempts++;
          var ok = this.wireNativeSecondary();
          if (ok) {
            this._secondaryWired = true;
          } else if (attempts < 10) {
            setTimeout(tryWire, 300);
          }
        };
        tryWire();
      }

      toggleRotation(stage) {
        stage.spinning = !stage.spinning;
        this.syncRotateBtn(stage);

        if (stage.mv) {
          if (stage.spinning) stage.mv.setAttribute('auto-rotate', '');
          else stage.mv.removeAttribute('auto-rotate');
        }
      }

      syncRotateBtn(stage) {
        if (!stage.rotateBtn) return;
        var on = stage.spinning;
        stage.rotateBtn.dataset.spinning = String(on);
        var pauseIcon = stage.rotateBtn.querySelector('.color-3d-viewer__icon-pause');
        var playIcon = stage.rotateBtn.querySelector('.color-3d-viewer__icon-play');
        if (pauseIcon) pauseIcon.hidden = !on;
        if (playIcon) playIcon.hidden = on;
        stage.rotateBtn.setAttribute('aria-label', on ? 'Drehung anhalten' : 'Drehung starten');
        stage.rotateBtn.title = on ? 'Drehung anhalten' : 'Drehung starten';
      }

      toggleFullscreen(stage) {
        var el = stage.wrap;
        var isFullscreen = document.fullscreenElement || document.webkitFullscreenElement;

        if (isFullscreen) {
          if (document.exitFullscreen) document.exitFullscreen();
          else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
          return;
        }

        if (el.requestFullscreen) el.requestFullscreen();
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
      }

      applyColorHex(stage, hex, target) {
        if (!stage || !stage.loaded) return;

        if (stage.three) {
          var seen = [];
          stage.three.turntable.traverse(function (node) {
            if (!node.isMesh || !node.material) return;
            var mats = Array.isArray(node.material) ? node.material : [node.material];
            mats.forEach(function (mat) {
              if (seen.indexOf(mat) !== -1) return;
              seen.push(mat);
              var matchesTarget = target === 'Body' ? (!mat.name || mat.name === 'Body') : mat.name === target;
              if (!matchesTarget) return;
              if (mat.color) mat.color.set(hex);
              if ('metalness' in mat) mat.metalness = 0;
              if ('roughness' in mat) mat.roughness = 0.55;
            });
          });
          return;
        }

        if (stage.mv) {
          var r = parseInt(hex.slice(1, 3), 16) / 255;
          var g = parseInt(hex.slice(3, 5), 16) / 255;
          var b = parseInt(hex.slice(5, 7), 16) / 255;
          var model = stage.mv.model;
          if (!model) return;
          model.materials.forEach((mat) => {
            var matchesTarget = target === 'Body' ? (!mat.name || mat.name === 'Body') : mat.name === target;
            if (!matchesTarget) return;
            if (mat.pbrMetallicRoughness) {
              mat.pbrMetallicRoughness.setBaseColorFactor([r, g, b, 1]);
              mat.pbrMetallicRoughness.setMetallicFactor(0);
              mat.pbrMetallicRoughness.setRoughnessFactor(0.55);
            }
          });
        }
      }
    }

    if (!customElements.get('color-3d-viewer')) {
      customElements.define('color-3d-viewer', Color3dViewer);
    }

    // Variantenwechsel: Horizons variant-picker.js feuert 'variant:update' (bubbles) mit dem
    // kompletten neu vom Server gerenderten Dokument im detail — genau wie media-gallery.js
    // ersetzen wir unseren Slot-Wrapper 1:1 durch die frische Fassung (neues Modell oder leer).
    if (!window.__color3dViewerVariantListener) {
      window.__color3dViewerVariantListener = true;
      document.addEventListener('variant:update', function (event) {
        var html = event && event.detail && event.detail.data && event.detail.data.html;
        if (!html) return;
        var newSlots = html.querySelectorAll('[data-color-3d-viewer-slot]');
        var oldSlots = document.querySelectorAll('[data-color-3d-viewer-slot]');
        oldSlots.forEach(function (oldSlot, i) {
          var newSlot = newSlots[i];
          if (newSlot) oldSlot.replaceWith(newSlot);
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["photo-configurator"] && !Shopify.designMode) return;
  try {
    (function () {
    var THREE_CDN = 'https://cdn.jsdelivr.net/npm/three@0.169.0';

    function loadThreeModules() {
      if (!window.__m3dThreePromise) {
        var p = Promise.all([
          import(THREE_CDN + '/+esm'),
          import(THREE_CDN + '/examples/jsm/controls/OrbitControls.js/+esm'),
          import(THREE_CDN + '/examples/jsm/loaders/GLTFLoader.js/+esm'),
          import(THREE_CDN + '/examples/jsm/environments/RoomEnvironment.js/+esm'),
        ]).then(function (mods) {
          return { THREE: mods[0], OrbitControls: mods[1].OrbitControls, GLTFLoader: mods[2].GLTFLoader, RoomEnvironment: mods[3].RoomEnvironment };
        });
        p.catch(function () { if (window.__m3dThreePromise === p) window.__m3dThreePromise = null; });
        window.__m3dThreePromise = p;
      }
      return window.__m3dThreePromise;
    }

    var DPI = 300;
    var MM_PER_INCH = 25.4;
    var CORNER_RADIUS_MM = 0;
    var NORMAL_BAKE_STRENGTH = 16;
    // Echte Fotos haben nur sanfte Helligkeitsverlaeufe zwischen Nachbarpixeln (Sobel-Gradient
    // bei Schrittweite 1 ist dadurch fast immer < 0.02) -> mit Schrittweite 1 blieb das Relief
    // auf realen Fotos praktisch unsichtbar. Groessere Abtastweite bringt genug Signal; die Staerke
    // wurde per Live-Test kalibriert: 25 kippt Normalen fast ueberall auf >70 Grad und ersaeuft das
    // Relief in gleichfoermiger Verdunklung statt Licht/Schatten-Kontrast, 16 zeigt einen klar
    // sichtbaren, aber sauberen Reliefeffekt ohne diesen Kollaps.
    var SAMPLE_STEP = 5;
    var MAX_MEGAPIXELS = 40;
    // Wie beim bestehenden 3D-Farbkonfigurator (color-3d-viewer.liquid): staticisches Licht macht
    // eine Normal-Map-Reliefstruktur kaum sichtbar. Erst dauerhaft wanderndes Licht bringt die
    // Struktur ueber wechselnde Licht-/Schattenkanten zum Vorschein ("Displate-Effekt").
    var LIGHT_AZIMUTH_SPEED = 0.55; // rad/s
    var LIGHT_ELEVATION_BASE = (40 * Math.PI) / 180;
    var LIGHT_ELEVATION_SWING = (25 * Math.PI) / 180;
    var LIGHT_ELEVATION_SPEED = 0.23;
    var REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }

    function drawComposite(ctx, w, h, img, transform) {
      ctx.save();
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, w, h);
      if (img) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(0, 0, w, h);
        ctx.clip();
        ctx.translate(w / 2 + transform.offsetX * w, h / 2 + transform.offsetY * h);
        ctx.rotate(transform.rotation);
        ctx.scale(transform.scale, transform.scale);
        var baseScale = transform.fitMode === 'contain'
          ? Math.min(w / img.width, h / img.height)
          : Math.max(w / img.width, h / img.height);
        var drawW = img.width * baseScale;
        var drawH = img.height * baseScale;
        ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
        ctx.restore();
      }
      ctx.restore();
    }

    function computeExportPixelSize(plate, dpi) {
      return { w: Math.round((plate.w / MM_PER_INCH) * dpi), h: Math.round((plate.h / MM_PER_INCH) * dpi) };
    }

    function toLuminance(imageData) {
      var data = imageData.data, width = imageData.width, height = imageData.height;
      var lum = new Float32Array(width * height);
      for (var i = 0; i < width * height; i++) {
        var o = i * 4;
        lum[i] = (0.299 * data[o] + 0.587 * data[o + 1] + 0.114 * data[o + 2]) / 255;
      }
      return lum;
    }

    function generateNormalMapCanvas(sourceCanvas, invert) {
      var w = sourceCanvas.width, h = sourceCanvas.height;
      var srcCtx = sourceCanvas.getContext('2d');
      var lum = toLuminance(srcCtx.getImageData(0, 0, w, h));
      var sign = invert ? -1 : 1;
      var out = document.createElement('canvas');
      out.width = w; out.height = h;
      var octx = out.getContext('2d');
      var outData = octx.createImageData(w, h);
      function at(x, y) {
        var cx = x < 0 ? 0 : x >= w ? w - 1 : x;
        var cy = y < 0 ? 0 : y >= h ? h - 1 : y;
        return lum[cy * w + cx];
      }
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var tl = at(x - SAMPLE_STEP, y - SAMPLE_STEP), t = at(x, y - SAMPLE_STEP), tr = at(x + SAMPLE_STEP, y - SAMPLE_STEP);
          var l = at(x - SAMPLE_STEP, y), r = at(x + SAMPLE_STEP, y);
          var bl = at(x - SAMPLE_STEP, y + SAMPLE_STEP), b = at(x, y + SAMPLE_STEP), br = at(x + SAMPLE_STEP, y + SAMPLE_STEP);
          var gx = (tr + 2 * r + br) - (tl + 2 * l + bl);
          var gy = (bl + 2 * b + br) - (tl + 2 * t + tr);
          var nx = -gx * NORMAL_BAKE_STRENGTH * sign;
          var ny = gy * NORMAL_BAKE_STRENGTH * sign;
          var nz = 1.0;
          var len = Math.sqrt(nx * nx + ny * ny + nz * nz) || 1;
          nx /= len; ny /= len; nz /= len;
          var o = (y * w + x) * 4;
          outData.data[o] = Math.round((nx * 0.5 + 0.5) * 255);
          outData.data[o + 1] = Math.round((ny * 0.5 + 0.5) * 255);
          outData.data[o + 2] = Math.round((nz * 0.5 + 0.5) * 255);
          outData.data[o + 3] = 255;
        }
      }
      octx.putImageData(outData, 0, 0);
      return out;
    }

    function generateHeightMapCanvas(sourceCanvas, invert) {
      var w = sourceCanvas.width, h = sourceCanvas.height;
      var src = sourceCanvas.getContext('2d').getImageData(0, 0, w, h);
      var out = document.createElement('canvas');
      out.width = w; out.height = h;
      var octx = out.getContext('2d');
      var outData = octx.createImageData(w, h);
      for (var i = 0; i < w * h; i++) {
        var o = i * 4;
        var v = 0.299 * src.data[o] + 0.587 * src.data[o + 1] + 0.114 * src.data[o + 2];
        if (invert) v = 255 - v;
        outData.data[o] = outData.data[o + 1] = outData.data[o + 2] = v;
        outData.data[o + 3] = 255;
      }
      octx.putImageData(outData, 0, 0);
      return out;
    }

    function crc32(bytes) {
      var crc = 0xFFFFFFFF;
      for (var i = 0; i < bytes.length; i++) {
        var c = (crc ^ bytes[i]) & 0xFF;
        for (var k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
        crc = (crc >>> 8) ^ c;
      }
      return (crc ^ 0xFFFFFFFF) >>> 0;
    }

    function injectPngDpi(arrayBuffer, dpi) {
      var bytes = new Uint8Array(arrayBuffer);
      var pxPerMeter = Math.round(dpi / 0.0254);
      var type = new Uint8Array([0x70, 0x48, 0x59, 0x73]);
      var data = new Uint8Array(9);
      var dv = new DataView(data.buffer);
      dv.setUint32(0, pxPerMeter, false);
      dv.setUint32(4, pxPerMeter, false);
      data[8] = 1;
      var body = new Uint8Array(type.length + data.length);
      body.set(type, 0); body.set(data, type.length);
      var crc = crc32(body);
      var chunk = new Uint8Array(4 + body.length + 4);
      new DataView(chunk.buffer).setUint32(0, data.length, false);
      chunk.set(body, 4);
      new DataView(chunk.buffer).setUint32(4 + body.length, crc, false);
      var insertPos = 8 + 25;
      var out = new Uint8Array(bytes.length + chunk.length);
      out.set(bytes.subarray(0, insertPos), 0);
      out.set(chunk, insertPos);
      out.set(bytes.subarray(insertPos), insertPos + chunk.length);
      return out.buffer;
    }

    function canvasToDpiPng(canvas, dpi) {
      return new Promise(function (resolve) { canvas.toBlob(resolve, 'image/png'); })
        .then(function (blob) { return blob.arrayBuffer(); })
        .then(function (buf) { return new Blob([injectPngDpi(buf, dpi)], { type: 'image/png' }); });
    }

    function createRoundedRectShape(THREE, width, height, radius) {
      var shape = new THREE.Shape();
      var w = width / 2, h = height / 2;
      var r = Math.min(radius, Math.min(width, height) / 2);
      shape.moveTo(-w + r, -h);
      shape.lineTo(w - r, -h);
      shape.quadraticCurveTo(w, -h, w, -h + r);
      shape.lineTo(w, h - r);
      shape.quadraticCurveTo(w, h, w - r, h);
      shape.lineTo(-w + r, h);
      shape.quadraticCurveTo(-w, h, -w, h - r);
      shape.lineTo(-w, -h + r);
      shape.quadraticCurveTo(-w, -h, -w + r, -h);
      return shape;
    }

    class PhotoConfigurator extends HTMLElement {
      connectedCallback() {
        this._ac = new AbortController();
        var signal = this._ac.signal;
        var self = this;

        try { this.plates = JSON.parse(this.dataset.plates || '[]'); } catch (e) { this.plates = []; }
        if (!this.plates.length) return;
        this.sizeOptionName = this.dataset.sizeOptionName || 'Größe';

        this.state = {
          plate: this.plates[0],
          thicknessMM: this.plates[0].thicknessMM,
          cornerRadiusMM: CORNER_RADIUS_MM,
          reliefStrength: 0.8,
          reliefInvert: false,
          sourceImage: null,
          sourceFileName: '',
          transform: { offsetX: 0, offsetY: 0, scale: 1, rotation: 0, fitMode: 'cover' },
          dragging: false,
          dragStart: null,
          activePointerId: null,
          uploadSeq: 0,
          payloadSeq: 0,
        };

        this.dropzone = this.querySelector('[data-pcfg-dropzone]');
        this.fileInput = this.querySelector('[data-pcfg-file-input]');
        this.fileInfo = this.querySelector('[data-pcfg-file-info]');
        this.editWrap = this.querySelector('[data-pcfg-edit-wrap]');
        this.editCanvas = this.querySelector('[data-pcfg-edit-canvas]');
        this.editCtx = this.editCanvas.getContext('2d');
        this.scaleSlider = this.querySelector('[data-pcfg-scale-slider]');
        this.scaleValue = this.querySelector('[data-pcfg-scale-value]');
        this.rotationSlider = this.querySelector('[data-pcfg-rotation-slider]');
        this.rotationValue = this.querySelector('[data-pcfg-rotation-value]');
        this.fitCoverBtn = this.querySelector('[data-pcfg-fit-cover]');
        this.fitContainBtn = this.querySelector('[data-pcfg-fit-contain]');
        this.resetBtn = this.querySelector('[data-pcfg-reset]');
        this.viewerEl = this.querySelector('[data-pcfg-viewer]');
        this.viewerHint = this.querySelector('[data-pcfg-viewer-hint]');
        this.autoRotateBtn = this.querySelector('[data-pcfg-autorotate]');
        this.reliefSlider = this.querySelector('[data-pcfg-relief-slider]');
        this.reliefValue = this.querySelector('[data-pcfg-relief-value]');
        this.reliefInvertEl = this.querySelector('[data-pcfg-relief-invert]');
        this.statusEl = this.querySelector('[data-pcfg-status]');
        this.toastEl = this.querySelector('[data-pcfg-toast]');

        this.textureCanvas = document.createElement('canvas');
        this.textureCtx = this.textureCanvas.getContext('2d', { willReadFrequently: true });

        this.setControlsEnabled(false);
        this.syncEditCanvasSize();
        this.redrawEditCanvas();

        this.wireUpload(signal);
        this.wireEditInteraction(signal);
        this.wireSliders(signal);
        this.wireNativeSize(signal);
        this.initThree();
        this.ensureFormWired();
        this.suppressDuplicatePhotoField();

        document.addEventListener('variant:update', function () { self.ensureFormWired(); self.suppressDuplicatePhotoField(); }, { signal: signal });
      }

      // Stopgap: Die App "Globo Product Options" hat auf diesem Produkt noch ein eigenes,
      // aelteres Pflicht-Upload-Feld ("Eigenes Foto") konfiguriert - ein Relikt aus der Zeit vor
      // diesem Konfigurator. Das fuehrt zu einem doppelten Upload und blockierte per HTML5-
      // Pflichtfeld-Validierung den Kaufen-Button, obwohl unsere eigene Gestaltung laengst bereit
      // ist. WICHTIG: display:none allein reicht NICHT - ein via CSS verstecktes required-Feld
      // zaehlt in Chrome trotzdem als ungueltig (form.checkValidity() bleibt false, per Live-Test
      // bestaetigt). Das required-Attribut muss explizit entfernt werden, erst danach ist der
      // Kaufen-Button wieder benutzbar. Echte Loesung: die Option im Globo-App-Adminbereich
      // entfernen, dann kann dieser Block hier wieder raus.
      suppressDuplicatePhotoField() {
        var self = this;
        var tryHide = function () {
          var input = document.querySelector('input[name="properties[Eigenes Foto]"]');
          if (!input) return false;
          var wrapper = input.closest('.photo-upload-field') || input;
          if (wrapper.dataset.pcfgSuppressed) return true;
          input.required = false;
          input.removeAttribute('required');
          wrapper.style.display = 'none';
          wrapper.setAttribute('aria-hidden', 'true');
          wrapper.dataset.pcfgSuppressed = 'true';
          return true;
        };
        if (tryHide() || this._suppressAttempts >= 20) return;
        this._suppressAttempts = (this._suppressAttempts || 0) + 1;
        clearTimeout(this._suppressTimer);
        this._suppressTimer = setTimeout(function () { self.suppressDuplicatePhotoField(); }, 300);
      }

      disconnectedCallback() {
        if (this._ac) this._ac.abort();
        if (this._three) this.teardownThree();
        if (this._regenTimer) clearTimeout(this._regenTimer);
        if (this._payloadTimer) clearTimeout(this._payloadTimer);
        if (this._suppressTimer) clearTimeout(this._suppressTimer);
      }

      /* ---------------- Upload ---------------- */

      wireUpload(signal) {
        var self = this;
        this.dropzone.addEventListener('click', function () { self.fileInput.click(); }, { signal: signal });
        this.dropzone.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') self.fileInput.click(); }, { signal: signal });
        this.dropzone.addEventListener('dragover', function (e) { e.preventDefault(); self.dropzone.classList.add('dragover'); }, { signal: signal });
        this.dropzone.addEventListener('dragleave', function () { self.dropzone.classList.remove('dragover'); }, { signal: signal });
        this.dropzone.addEventListener('drop', function (e) {
          e.preventDefault();
          self.dropzone.classList.remove('dragover');
          var file = e.dataTransfer.files && e.dataTransfer.files[0];
          if (file) self.loadImageFile(file);
        }, { signal: signal });
        this.fileInput.addEventListener('change', function (e) {
          var file = e.target.files && e.target.files[0];
          if (file) self.loadImageFile(file);
        }, { signal: signal });
      }

      loadImageFile(file) {
        var self = this;
        if (!/^image\/(png|jpeg)$/.test(file.type)) {
          this.showToast('Bitte eine JPG- oder PNG-Datei hochladen.');
          return;
        }
        var seq = ++this.state.uploadSeq;
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          URL.revokeObjectURL(url);
          if (seq !== self.state.uploadSeq) return;
          var megapixels = (img.width * img.height) / 1000000;
          if (megapixels > MAX_MEGAPIXELS) {
            self.showToast('Foto zu groß (' + megapixels.toFixed(0) + ' MP). Bitte ein Foto bis ' + MAX_MEGAPIXELS + ' MP verwenden.');
            return;
          }
          self.state.sourceImage = img;
          self.state.sourceFileName = file.name;
          self.fileInfo.textContent = file.name + ' · ' + img.width + ' × ' + img.height + ' px';
          self.resetTransform('cover');
          self.setControlsEnabled(true);
          self.viewerHint.style.opacity = '0';
          self.schedulePayloadUpdate();
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          if (seq !== self.state.uploadSeq) return;
          self.showToast('Foto konnte nicht geladen werden.');
        };
        img.src = url;
      }

      setControlsEnabled(enabled) {
        [this.scaleSlider, this.rotationSlider, this.fitCoverBtn, this.fitContainBtn, this.resetBtn].forEach(function (el) { el.disabled = !enabled; });
      }

      /* ---------------- 2D-Editor ---------------- */

      syncEditCanvasSize() {
        var targetW = 600;
        var targetH = Math.round(targetW * this.state.plate.h / this.state.plate.w);
        this.editCanvas.width = targetW;
        this.editCanvas.height = targetH;
      }

      redrawEditCanvas() {
        drawComposite(this.editCtx, this.editCanvas.width, this.editCanvas.height, this.state.sourceImage, this.state.transform);
      }

      wireEditInteraction(signal) {
        var self = this;
        this.editWrap.addEventListener('pointerdown', function (e) {
          if (!self.state.sourceImage || self.state.dragging) return;
          self.state.dragging = true;
          self.state.activePointerId = e.pointerId;
          self.state.dragStart = { x: e.clientX, y: e.clientY, offsetX: self.state.transform.offsetX, offsetY: self.state.transform.offsetY };
          self.editWrap.classList.add('dragging');
          try { self.editWrap.setPointerCapture(e.pointerId); } catch (err) { /* Pointer evtl. schon losgelassen */ }
        }, { signal: signal });

        this.editWrap.addEventListener('pointermove', function (e) {
          if (!self.state.dragging || !self.state.dragStart || e.pointerId !== self.state.activePointerId) return;
          var rect = self.editWrap.getBoundingClientRect();
          var dx = (e.clientX - self.state.dragStart.x) / rect.width;
          var dy = (e.clientY - self.state.dragStart.y) / rect.height;
          self.state.transform.offsetX = self.state.dragStart.offsetX + dx;
          self.state.transform.offsetY = self.state.dragStart.offsetY + dy;
          self.onTransformChanged();
        }, { signal: signal });

        function endDrag(e) {
          if (!self.state.dragging) return;
          if (e && e.pointerId !== undefined && e.pointerId !== self.state.activePointerId) return;
          self.state.dragging = false;
          self.state.activePointerId = null;
          self.editWrap.classList.remove('dragging');
          self.state.dragStart = null;
        }
        this.editWrap.addEventListener('pointerup', endDrag, { signal: signal });
        this.editWrap.addEventListener('pointercancel', endDrag, { signal: signal });
        this.editWrap.addEventListener('pointerleave', function (e) { if (!self.editWrap.hasPointerCapture(e.pointerId)) endDrag(e); }, { signal: signal });

        this.editWrap.addEventListener('keydown', function (e) {
          if (!self.state.sourceImage) return;
          var step = e.shiftKey ? 0.05 : 0.015;
          if (e.key === 'ArrowLeft') self.state.transform.offsetX -= step;
          else if (e.key === 'ArrowRight') self.state.transform.offsetX += step;
          else if (e.key === 'ArrowUp') self.state.transform.offsetY -= step;
          else if (e.key === 'ArrowDown') self.state.transform.offsetY += step;
          else return;
          e.preventDefault();
          self.onTransformChanged();
        }, { signal: signal });

        this.editWrap.addEventListener('wheel', function (e) {
          if (!self.state.sourceImage) return;
          e.preventDefault();
          var dy = e.deltaMode === 1 ? e.deltaY * 18 : e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY;
          var factor = Math.exp(-dy * 0.0015);
          var next = clamp(self.state.transform.scale * factor, 0.2, 3);
          self.state.transform.scale = next;
          self.scaleSlider.value = Math.round(next * 100);
          self.scaleValue.textContent = Math.round(next * 100) + '%';
          self.onTransformChanged();
        }, { signal: signal, passive: false });
      }

      wireSliders(signal) {
        var self = this;
        this.scaleSlider.addEventListener('input', function () {
          self.state.transform.scale = Number(self.scaleSlider.value) / 100;
          self.scaleValue.textContent = self.scaleSlider.value + '%';
          self.onTransformChanged();
        }, { signal: signal });
        this.rotationSlider.addEventListener('input', function () {
          self.state.transform.rotation = Number(self.rotationSlider.value) * Math.PI / 180;
          self.rotationValue.textContent = self.rotationSlider.value + '°';
          self.onTransformChanged();
        }, { signal: signal });
        this.fitCoverBtn.addEventListener('click', function () { self.resetTransform('cover'); }, { signal: signal });
        this.fitContainBtn.addEventListener('click', function () { self.resetTransform('contain'); }, { signal: signal });
        this.resetBtn.addEventListener('click', function () { self.resetTransform(self.state.transform.fitMode); }, { signal: signal });
        this.reliefSlider.addEventListener('input', function () {
          self.state.reliefStrength = Number(self.reliefSlider.value) / 10;
          self.reliefValue.textContent = self.state.reliefStrength.toFixed(1);
          self.onReliefChanged();
        }, { signal: signal });
        this.reliefInvertEl.addEventListener('change', function () {
          self.state.reliefInvert = self.reliefInvertEl.checked;
          self.regenerateNormalMap();
          self.schedulePayloadUpdate();
        }, { signal: signal });
        this.autoRotateBtn.addEventListener('click', function () {
          if (!self._three) return;
          self._three.controls.autoRotate = !self._three.controls.autoRotate;
          self.autoRotateBtn.classList.toggle('active', self._three.controls.autoRotate);
        }, { signal: signal });
      }

      resetTransform(fitMode) {
        this.state.transform.offsetX = 0;
        this.state.transform.offsetY = 0;
        this.state.transform.scale = 1;
        this.state.transform.rotation = 0;
        this.state.transform.fitMode = fitMode || 'cover';
        this.scaleSlider.value = 100;
        this.scaleValue.textContent = '100%';
        this.rotationSlider.value = 0;
        this.rotationValue.textContent = '0°';
        this.onTransformChanged();
      }

      onTransformChanged() {
        this.redrawEditCanvas();
        this.redrawTextureCanvas();
        this.regenerateNormalMap();
        this.schedulePayloadUpdate();
      }

      onReliefChanged() {
        if (this._three && this._three.decalMaterial) {
          this._three.decalMaterial.normalScale.set(this.state.reliefStrength, this.state.reliefStrength);
        }
      }

      /* ---------------- Native Größenauswahl ---------------- */

      wireNativeSize(signal) {
        var self = this;
        var optionName = this.sizeOptionName;
        var inputs = Array.prototype.filter.call(document.querySelectorAll('input[type="radio"]'), function (i) {
          return i.name && i.name.indexOf(optionName + '-') === 0;
        });
        if (!inputs.length) return;
        inputs.forEach(function (input) {
          input.addEventListener('change', function () { self.applyPlateFromLabel(input.value); }, { signal: signal });
        });
        var checked = inputs.find(function (i) { return i.checked; });
        if (checked) this.applyPlateFromLabel(checked.value);
      }

      applyPlateFromLabel(label) {
        var match = this.plates.find(function (p) { return p.label === label; });
        if (!match || match === this.state.plate) return;
        this.state.plate = match;
        this.state.thicknessMM = match.thicknessMM;
        this.syncEditCanvasSize();
        this.syncTextureCanvasSize();
        this.rebuildBlock();
        this.redrawEditCanvas();
        this.redrawTextureCanvas();
        this.regenerateNormalMap();
        this.schedulePayloadUpdate();
      }

      /* ---------------- Textur-Canvases ---------------- */

      syncTextureCanvasSize() {
        var maxDim = 1024, w, h;
        if (this.state.plate.w >= this.state.plate.h) { w = maxDim; h = Math.round(maxDim * this.state.plate.h / this.state.plate.w); }
        else { h = maxDim; w = Math.round(maxDim * this.state.plate.w / this.state.plate.h); }
        this.textureCanvas.width = w;
        this.textureCanvas.height = h;
      }

      redrawTextureCanvas() {
        drawComposite(this.textureCtx, this.textureCanvas.width, this.textureCanvas.height, this.state.sourceImage, this.state.transform);
        if (this._three) this._three.colorTexture.needsUpdate = true;
      }

      regenerateNormalMap() {
        var self = this;
        clearTimeout(this._regenTimer);
        this._regenTimer = setTimeout(function () {
          if (!self._three) return;
          var nmCanvas = generateNormalMapCanvas(self.textureCanvas, self.state.reliefInvert);
          // Wiederverwenden der bestehenden Textur (nur .image tauschen + needsUpdate) liefert in diesem
          // Rendering-Setup eine kaputte, rein einfarbig abgedunkelte Normal-Map statt echter Licht/Schatten-
          // Zeichnung (live verifiziert) -> stattdessen jedes Mal eine frische CanvasTexture erzeugen.
          var THREE = self._three.THREE;
          var oldTexture = self._three.normalTexture;
          var freshTexture = new THREE.CanvasTexture(nmCanvas);
          freshTexture.flipY = oldTexture.flipY;
          self._three.normalTexture = freshTexture;
          if (self._three.decalMaterial) self._three.decalMaterial.normalMap = freshTexture;
          oldTexture.dispose();
        }, 120);
      }

      /* ---------------- Three.js ---------------- */

      initThree() {
        var self = this;
        this.syncTextureCanvasSize();
        loadThreeModules().then(function (mods) { self.buildThree(mods); }).catch(function (err) {
          console.warn('photo-configurator: Three.js nicht verfuegbar', err);
        });
      }

      buildThree(mods) {
        var THREE = mods.THREE;
        var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false });
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
        renderer.outputColorSpace = THREE.SRGBColorSpace;
        renderer.toneMapping = THREE.ACESFilmicToneMapping;
        renderer.toneMappingExposure = 1.05;
        this.viewerEl.appendChild(renderer.domElement);

        var scene = new THREE.Scene();
        scene.background = new THREE.Color(0xece3cf);

        var pmrem = new THREE.PMREMGenerator(renderer);
        scene.environment = pmrem.fromScene(new mods.RoomEnvironment(), 0.04).texture;
        if ('environmentIntensity' in scene) scene.environmentIntensity = 0.7;
        pmrem.dispose();

        var camera = new THREE.PerspectiveCamera(32, 1, 0.05, 200);
        camera.position.set(0, 6, 22);

        var controls = new mods.OrbitControls(camera, renderer.domElement);
        controls.enableDamping = true;
        controls.dampingFactor = 0.08;
        controls.enablePan = false;
        controls.autoRotate = false;
        controls.autoRotateSpeed = 2.4;

        var keyLight = new THREE.DirectionalLight(0xffffff, 2.0);
        keyLight.position.set(8, 10, 10);
        scene.add(keyLight);
        var fillLight = new THREE.DirectionalLight(0xffffff, 0.55);
        fillLight.position.set(-9, 4, -6);
        scene.add(fillLight);
        scene.add(new THREE.AmbientLight(0xffffff, 0.15));

        var colorTexture = new THREE.CanvasTexture(this.textureCanvas);
        colorTexture.colorSpace = THREE.SRGBColorSpace;
        var normalTexture = new THREE.CanvasTexture(document.createElement('canvas'));

        this._three = {
          THREE: THREE, renderer: renderer, scene: scene, camera: camera, controls: controls,
          colorTexture: colorTexture, normalTexture: normalTexture, keyLight: keyLight, fillLight: fillLight,
          blockMesh: null, decalMesh: null, decalMaterial: null, raf: 0, elapsed: 0, lastTime: 0, lightRadius: 3,
        };

        var self = this;
        this._three.resizeObserver = new ResizeObserver(function () { self.resizeRenderer(); });
        this._three.resizeObserver.observe(this.viewerEl);
        this.resizeRenderer();

        this.rebuildBlock();
        this.regenerateNormalMap();

        function tick(now) {
          if (!self._three) return;
          self._three.raf = requestAnimationFrame(tick);
          now = now || 0;
          if (!self._three.lastTime) self._three.lastTime = now;
          var delta = Math.min((now - self._three.lastTime) / 1000, 0.1);
          self._three.lastTime = now;
          if (!REDUCED_MOTION) self._three.elapsed += delta;

          var t = self._three.elapsed;
          var az = t * LIGHT_AZIMUTH_SPEED;
          var el = LIGHT_ELEVATION_BASE + LIGHT_ELEVATION_SWING * Math.sin(t * LIGHT_ELEVATION_SPEED);
          var R = self._three.lightRadius;
          self._three.keyLight.position.set(
            R * Math.cos(el) * Math.sin(az),
            R * Math.sin(el),
            R * Math.cos(el) * Math.cos(az)
          );
          var fillAz = az + Math.PI * 0.9, fillEl = (20 * Math.PI) / 180;
          self._three.fillLight.position.set(
            R * Math.cos(fillEl) * Math.sin(fillAz),
            R * Math.sin(fillEl),
            R * Math.cos(fillEl) * Math.cos(fillAz)
          );

          self._three.controls.update();
          self._three.renderer.render(self._three.scene, self._three.camera);
        }
        tick();
      }

      resizeRenderer() {
        if (!this._three) return;
        var w = this.viewerEl.clientWidth, h = this.viewerEl.clientHeight;
        if (w === 0 || h === 0) return;
        this._three.renderer.setSize(w, h, false);
        this._three.camera.aspect = w / h;
        this._three.camera.updateProjectionMatrix();
      }

      rebuildBlock() {
        if (!this._three) return;
        var THREE = this._three.THREE;
        var scene = this._three.scene;

        if (this._three.blockMesh) { scene.remove(this._three.blockMesh); this._three.blockMesh.geometry.dispose(); this._three.blockMesh.material.dispose(); }
        if (this._three.decalMesh) { scene.remove(this._three.decalMesh); this._three.decalMesh.geometry.dispose(); this._three.decalMesh.material.dispose(); }

        var plateW = this.state.plate.w / 10;
        var plateH = this.state.plate.h / 10;
        var thickness = this.state.thicknessMM / 10;
        var cornerRadius = this.state.cornerRadiusMM / 10;
        var bevel = Math.min(thickness * 0.18, cornerRadius * 0.6, 0.06);

        var shape = createRoundedRectShape(THREE, plateW, plateH, cornerRadius);
        var geometry = new THREE.ExtrudeGeometry(shape, {
          depth: Math.max(thickness - bevel * 2, 0.02),
          bevelEnabled: true, bevelThickness: bevel, bevelSize: bevel, bevelSegments: 6, curveSegments: 16,
        });
        geometry.center();

        var material = new THREE.MeshPhysicalMaterial({
          color: 0xf3f5fa, transparent: true, opacity: 0.5, roughness: 0.08, metalness: 0,
          clearcoat: 0.6, clearcoatRoughness: 0.12, envMapIntensity: 1.1, side: THREE.DoubleSide, depthWrite: false,
        });
        this._three.blockMesh = new THREE.Mesh(geometry, material);
        scene.add(this._three.blockMesh);

        var margin = Math.max(cornerRadius * 0.5, 0.08);
        var decalW = Math.max(plateW - margin * 2, 0.1);
        var decalH = Math.max(plateH - margin * 2, 0.1);
        var decalMaterial = new THREE.MeshStandardMaterial({
          map: this._three.colorTexture, normalMap: this._three.normalTexture,
          normalScale: new THREE.Vector2(this.state.reliefStrength, this.state.reliefStrength),
          // roughness hoch + envMapIntensity niedrig: eine glaenzende Decal-Flaeche spiegelt die helle
          // RoomEnvironment so stark, dass Foto-Kontrast UND Relief-Schattierung optisch "ausgewaschen"
          // wirken (per Live-Test bestaetigt - bei envMapIntensity:1 kaum noch Bildinhalt erkennbar,
          // bei 0.15 klar sichtbar). Der Acrylblock selbst (blockMaterial) bleibt bewusst glaenzend.
          roughness: 0.75, metalness: 0, envMapIntensity: 0.15,
        });
        this._three.decalMaterial = decalMaterial;
        this._three.decalMesh = new THREE.Mesh(new THREE.PlaneGeometry(decalW, decalH, 1, 1), decalMaterial);
        this._three.decalMesh.position.z = thickness / 2 + 0.03;
        scene.add(this._three.decalMesh);

        var sphereR = Math.sqrt(plateW * plateW + plateH * plateH) / 2;
        this._three.controls.minDistance = sphereR * 1.6;
        this._three.controls.maxDistance = sphereR * 5.5;
        this._three.lightRadius = sphereR * 2.6;
        this._three.camera.position.setLength(clamp(this._three.camera.position.length(), this._three.controls.minDistance, this._three.controls.maxDistance));
      }

      teardownThree() {
        if (!this._three) return;
        var t = this._three;
        this._three = null;
        if (t.raf) cancelAnimationFrame(t.raf);
        if (t.resizeObserver) t.resizeObserver.disconnect();
        if (t.controls) t.controls.dispose();
        if (t.renderer) {
          t.renderer.dispose();
          try { t.renderer.forceContextLoss(); } catch (e) { /* Kontext ggf. schon verloren */ }
          if (t.renderer.domElement && t.renderer.domElement.parentNode) t.renderer.domElement.parentNode.removeChild(t.renderer.domElement);
        }
      }

      /* ---------------- Druckdaten + Warenkorb-Anbindung ---------------- */

      schedulePayloadUpdate() {
        var self = this;
        clearTimeout(this._payloadTimer);
        this.setStatus('Vorschau wird vorbereitet …', false);
        this.setBuyButtonEnabled(false);
        this._payloadTimer = setTimeout(function () { self.buildAndWirePayload(); }, 700);
      }

      buildAndWirePayload() {
        var self = this;
        var seq = ++this.state.payloadSeq;
        if (!this.state.sourceImage) { this.ensureFormWired(); return; }

        var plate = this.state.plate, transform = { offsetX: this.state.transform.offsetX, offsetY: this.state.transform.offsetY, scale: this.state.transform.scale, rotation: this.state.transform.rotation, fitMode: this.state.transform.fitMode };
        var thicknessMM = this.state.thicknessMM, cornerRadiusMM = this.state.cornerRadiusMM;
        var reliefStrength = this.state.reliefStrength, reliefInvert = this.state.reliefInvert;
        var sourceImage = this.state.sourceImage, sourceFileName = this.state.sourceFileName;

        var px = computeExportPixelSize(plate, DPI);
        var printCanvas = document.createElement('canvas');
        printCanvas.width = px.w; printCanvas.height = px.h;
        drawComposite(printCanvas.getContext('2d'), px.w, px.h, sourceImage, transform);

        canvasToDpiPng(printCanvas, DPI).then(function (printBlob) {
          if (seq !== self.state.payloadSeq) return null;
          var heightCanvas = generateHeightMapCanvas(printCanvas, reliefInvert);
          return canvasToDpiPng(heightCanvas, DPI).then(function (bumpBlob) {
            if (seq !== self.state.payloadSeq) return;
            var jsonPayload = {
              generatedAt: new Date().toISOString(),
              sourceFileName: sourceFileName,
              sourceImagePx: { width: sourceImage.width, height: sourceImage.height },
              plate: { label: plate.label, width_mm: plate.w, height_mm: plate.h, thickness_mm: thicknessMM, cornerRadius_mm: cornerRadiusMM },
              dpi: DPI, exportPixelSize: px,
              transform: { fitMode: transform.fitMode, offsetX_fraction: transform.offsetX, offsetY_fraction: transform.offsetY, scale: transform.scale, rotation_deg: transform.rotation * 180 / Math.PI },
              relief: { strength: reliefStrength, inverted: reliefInvert },
            };
            self._payload = { printPngBlob: printBlob, bumpPngBlob: bumpBlob, jsonPayload: jsonPayload, sourceFileName: sourceFileName };
            self.ensureFormWired();
            self.setStatus('Bereit – deine Gestaltung wird beim Kauf automatisch mitgeschickt.', true);
            self.setBuyButtonEnabled(true);
          });
        }).catch(function (err) {
          console.warn('photo-configurator: Druckdatei konnte nicht erzeugt werden', err);
          self.setStatus('Vorschau konnte nicht erzeugt werden. Bitte anderes Foto versuchen.', false);
        });
      }

      findCartForm() {
        return document.querySelector('form[action^="/cart/add"]');
      }

      ensureFormWired() {
        var form = this.findCartForm();
        if (!form) return;
        if (form.__pcfgWired) {
          this.applyPayloadToForm(form);
          return;
        }
        form.__pcfgWired = true;
        var printInput = document.createElement('input');
        printInput.type = 'file'; printInput.hidden = true; printInput.name = 'properties[_Druckdatei]';
        var bumpInput = document.createElement('input');
        bumpInput.type = 'file'; bumpInput.hidden = true; bumpInput.name = 'properties[_Bump-Map]';
        var jsonInput = document.createElement('input');
        jsonInput.type = 'hidden'; jsonInput.name = 'properties[_Transformation]';
        form.appendChild(printInput); form.appendChild(bumpInput); form.appendChild(jsonInput);
        form.__pcfgInputs = { printInput: printInput, bumpInput: bumpInput, jsonInput: jsonInput };
        this.applyPayloadToForm(form);
      }

      applyPayloadToForm(form) {
        var inputs = form.__pcfgInputs;
        if (!inputs) return;
        if (this._payload) {
          var dtPrint = new DataTransfer();
          dtPrint.items.add(new File([this._payload.printPngBlob], this._payload.sourceFileName + '_druck.png', { type: 'image/png' }));
          inputs.printInput.files = dtPrint.files;
          var dtBump = new DataTransfer();
          dtBump.items.add(new File([this._payload.bumpPngBlob], this._payload.sourceFileName + '_bump.png', { type: 'image/png' }));
          inputs.bumpInput.files = dtBump.files;
          inputs.jsonInput.value = JSON.stringify(this._payload.jsonPayload);
        }
        this.setBuyButtonEnabled(!!this._payload);
      }

      setBuyButtonEnabled(enabled) {
        var form = this.findCartForm();
        if (!form) return;
        var btn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = !enabled;
      }

      setStatus(text, ready) {
        this.statusEl.textContent = text;
        this.statusEl.classList.toggle('pcfg-status--ready', !!ready);
      }

      showToast(msg) {
        var self = this;
        this.toastEl.textContent = msg;
        this.toastEl.classList.add('show');
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(function () { self.toastEl.classList.remove('show'); }, 2600);
      }
    }

    if (!customElements.get('photo-configurator')) {
      customElements.define('photo-configurator', PhotoConfigurator);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
